import React from "react";
import TablaSucursalBeneficio from "js/components/TablaSucursalCatalogoCodigos";

function SucursalBeneficio(props) {
  return <TablaSucursalBeneficio />;
}

export default SucursalBeneficio;
